import { ROLE_LIST_ACTION_TYPES } from 'store/actions/role-list.actions';

const initialState = {};

export default function (state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case ROLE_LIST_ACTION_TYPES.ROLE_LIST_SET_DATA_BY_KEY:
      return { ...state, [payload.stateKeyForDataSaving]: payload.data };

    case ROLE_LIST_ACTION_TYPES.ROLE_LIST_CHANGE_PROCESSING:
      return {
        ...state,
        processing: {
          ...state.processing,
          [payload.processingDestination]: payload.newState,
        },
      };

    case ROLE_LIST_ACTION_TYPES.ROLE_LIST_CHANGE_STATUS:
      return { ...state, status: payload };

    default:
      return state;
  }
}
